import React from 'react'
import DashBoard from '../Components/Admin/DashBoard'

function DashboardPage() {
  return (
    <>
        <DashBoard/>
    </>
  )
}

export default DashboardPage